'use client';
import { twMerge } from 'tailwind-merge';
import { useUserProfile } from '@/hooks/useUserProfile';
import { useEffect, useState } from 'react';

const Footer = ({ className, ...props }) => {
  const { school, isLoading } = useUserProfile();
  const [userRole, setUserRole] = useState(null);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const role = sessionStorage.getItem('userRole');
      setUserRole(role);
    }
  }, []);

  const schoolName = userRole === 'superadmin'
    ? 'Kaympus '
    : (school?.schoolName || 'Kaympus ');

  return (
    <footer
      className={twMerge(
        'hidden xl:block w-full bg-secondary-background border-t border-border-primary',
        className
      )}
      {...props}
    >
      <div className="px-6 py-3">
        <p className="text-sm font-normal text-text-secondary">
          Copyright © {new Date().getFullYear()} - {isLoading ? 'Loading...' : schoolName}
        </p>
      </div>
    </footer>
  )
}

export default Footer
